import { Box, Typography } from '@mui/material';

const EmptyState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
        p: 3,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          p: 4,
          borderRadius: 2,
          bgcolor: 'background.paper',
          boxShadow: 1,
        }}
      >
        <Typography variant="h5" gutterBottom>
          Please select a report from the header above
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Click on any report type to view its details
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;

